
<template>
  <section v-html="content" v-once />
</template>
<script>
export default {
  created() {
    this.content = unescape(`%3Ch1%3E%u5FEB%u901F%u4E0A%u624B%3C/h1%3E%0A%3Cdiv%20class%3D%22card%22%3E%3Ch3%20id%3D%22an-zhuang%22%3E%u5B89%u88C5%3C/h3%3E%0A%3Cpre%3E%3Ccode%20class%3D%22language-bash%22%3E%3Cspan%20class%3D%22hljs-comment%22%3E%23%20%u901A%u8FC7%20npm%3C/span%3E%0Anpm%20i%20beyond-ui%0A%0A%3Cspan%20class%3D%22hljs-comment%22%3E%23%20%u901A%u8FC7%20yarn%3C/span%3E%0Ayarn%20add%20beyond-ui%0A%0A%3Cspan%20class%3D%22hljs-comment%22%3E%23%20%u901A%u8FC7%20pnpm%3C/span%3E%0Apnpm%20add%20beyond-ui%0A%3C/code%3E%3C/pre%3E%0A%3C/div%3E%3Cdiv%20class%3D%22card%22%3E%3Ch3%20id%3D%22yin-ru-zu-jian-ku%22%3E%u5F15%u5165%u7EC4%u4EF6%u5E93%3C/h3%3E%0A%3Cpre%3E%3Ccode%20class%3D%22language-js%22%3E%3Cspan%20class%3D%22hljs-comment%22%3E//%20%u5168%u90E8%u5F15%u5165%3C/span%3E%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eimport%3C/span%3E%20BeyondUI%20%3Cspan%20class%3D%22hljs-keyword%22%3Efrom%3C/span%3E%20%3Cspan%20class%3D%22hljs-string%22%3E%26%23x27%3Bbeyond-ui%26%23x27%3B%3C/span%3E%3B%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eimport%3C/span%3E%20%3Cspan%20class%3D%22hljs-string%22%3E%26%23x27%3Bbeyond-ui/lib/style/index.css%26%23x27%3B%3C/span%3E%3B%0AVue.use%28BeyondUI%29%3B%0A%0A%3Cspan%20class%3D%22hljs-comment%22%3E//%20%u6309%u9700%u5F15%u7528%3C/span%3E%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eimport%3C/span%3E%20%7B%20banner%20%7D%20%3Cspan%20class%3D%22hljs-keyword%22%3Efrom%3C/span%3E%20%3Cspan%20class%3D%22hljs-string%22%3E%26%23x27%3Bbeyond-ui%26%23x27%3B%3C/span%3E%3B%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eimport%3C/span%3E%20%3Cspan%20class%3D%22hljs-string%22%3E%26%23x27%3Bbeyond-ui/lib/banner/style%26%23x27%3B%3C/span%3E%3B%0AVue.use%28banner%29%3B%0A%3C/code%3E%3C/pre%3E%0A%3C/div%3E`);
  },
mounted() {
    const anchors = [].slice.call(this.$el.querySelectorAll('h2, h3, h4, h5'));
    anchors.forEach(anchor => {
      anchor.addEventListener('click', this.scrollToAnchor);
    });
  },
  methods: {
    scrollToAnchor(event) {
      if (event.target.id) {
        this.$router.push({
          path: this.$route.path,
          hash: event.target.id
        })
      }
    }
  },

};
</script>
